import React from 'react'
import css from './WhatYouGetClasses.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
 
import { FormattedMessage, useIntl } from '../../../../../util/reactIntl';
import learning from '../../../../../assets/Video-tutorial.gif';

function WhatYouGetClasses() {
  const intl = useIntl();
  const missionItems = [
    {
      icon: <IconCard type="groupclasses" />,
      titleId: 'WhatYouGetClasses.item1.title',
      descId: 'WhatYouGetClasses.item1.desc',
      altId: 'WhatYouGetClasses.item1.alt',
    },
    {
      icon: <IconCard type="arabworld"/>,
      titleId: 'WhatYouGetClasses.item2.title',
      descId: 'WhatYouGetClasses.item2.desc',
      altId: 'WhatYouGetClasses.item2.alt',
    },
    {
      icon: <IconCard type="structure"/>,
      titleId: 'WhatYouGetClasses.item3.title',
      descId: 'WhatYouGetClasses.item3.desc',
      altId: 'WhatYouGetClasses.item3.alt',
    },
  ];

  return (
    <div className={css.missionWrapper}>
      <div className={css.missionLeft}>
        <ul>
          {missionItems.map((item, i) => {
            return (
              <li key={i}>
                <div className={css.missionIcon}>
                  <span className={css.icon}>
                    {item.icon}
                  </span>
                </div>
                <div className={css.listHeadCard}>
                  <h3>
                    <FormattedMessage id={item.titleId} />
                  </h3>
                  <p>
                    <FormattedMessage id={item.descId} />
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={css.missionRight}>
        <div className={css.missionMainHeading}>
          <FormattedMessage id="WhatYouGetClasses.mainHeading" />
        </div>
        <div className={css.missionHeading}>
          <FormattedMessage id="WhatYouGetClasses.heading" />
        </div>
        <div className={css.missionDescription}>
          <FormattedMessage id="WhatYouGetClasses.description" />
        </div>
        <div className={css.valueBook}>
          <img src={learning} alt="" />
          {/* <video> <source src={learning} type="video/mp4" /></video> */}
        </div>
      </div>
    </div>
  )
}

export default WhatYouGetClasses